document.addEventListener("DOMContentLoaded", () => {
  // Phipower2 gallery: thumbs + pijlen + zoom-lightbox (vanilla, geen dependencies)
  if (document.querySelector(".pp2-lightbox")) return; // idempotent

  const lb = document.createElement("div");
  lb.className = "pp2-lightbox";
  lb.setAttribute("role", "dialog");
  lb.setAttribute("aria-modal", "true");
  lb.setAttribute("aria-label", "Photo viewer");
  lb.innerHTML =
    '<button type="button" class="pp2-lb-close" aria-label="Close">&times;</button>' +
    '<button type="button" class="pp2-lb-nav pp2-lb-prev" aria-label="Previous photo">&#8249;</button>' +
    '<img class="pp2-lb-img" alt="">' +
    '<button type="button" class="pp2-lb-nav pp2-lb-next" aria-label="Next photo">&#8250;</button>' +
    '<span class="pp2-lb-hint">Scroll of tik om te zoomen &middot; swipe om te bladeren</span>';
  const st = document.createElement("style");
  st.textContent = `
.pp2-lightbox{position:fixed;inset:0;z-index:99999;background:rgba(15,23,42,.96);display:none;align-items:center;justify-content:center;touch-action:none}
.pp2-lightbox.is-open{display:flex}
.pp2-lb-img{max-width:92vw;max-height:88vh;object-fit:contain;transform-origin:0 0;transition:transform .18s ease-out;cursor:zoom-in;user-select:none;-webkit-user-drag:none}
.pp2-lightbox.is-zoomed .pp2-lb-img{cursor:grab;transition:none}
.pp2-lightbox.is-zoomed .pp2-lb-img:active{cursor:grabbing}
.pp2-lb-close{position:fixed;top:14px;right:18px;z-index:2;background:none;border:none;color:#fff;font-size:38px;line-height:1;cursor:pointer;opacity:.85;padding:6px 10px}
.pp2-lb-close:hover{opacity:1}
.pp2-lb-nav{position:fixed;top:50%;transform:translateY(-50%);z-index:2;background:rgba(255,255,255,.12);border:1px solid rgba(255,255,255,.25);color:#fff;font-size:30px;width:52px;height:52px;border-radius:50%;cursor:pointer;display:grid;place-items:center;backdrop-filter:blur(4px)}
.pp2-lb-nav:hover{background:rgba(255,255,255,.22)}
.pp2-lb-nav:disabled{opacity:.25;cursor:default}
.pp2-lb-prev{left:16px}.pp2-lb-next{right:16px}
.pp2-lb-hint{position:fixed;bottom:16px;left:50%;transform:translateX(-50%);color:rgba(255,255,255,.75);font-size:12.5px;letter-spacing:.02em;background:rgba(15,23,42,.55);padding:6px 14px;border-radius:999px;pointer-events:none}
@media (max-width:749px){.pp2-lb-nav{width:42px;height:42px;font-size:24px}.pp2-lb-prev{left:8px}.pp2-lb-next{right:8px}}
`;
  document.head.appendChild(st);
  document.body.appendChild(lb);

  const lbImg = lb.querySelector(".pp2-lb-img");
  const lbPrev = lb.querySelector(".pp2-lb-prev");
  const lbNext = lb.querySelector(".pp2-lb-next");
  const lbClose = lb.querySelector(".pp2-lb-close");
  let cur = 0, scale = 1, tx = 0, ty = 0;
  let dragStart = null, panStart = null, lastTap = 0;

  function applyTf() {
    lbImg.style.transform = "translate(" + tx + "px," + ty + "px) scale(" + scale + ")";
  }
  function resetZoom() {
    scale = 1; tx = 0; ty = 0; lb.classList.remove("is-zoomed"); applyTf();
  }
  function show(idx, imgs) {
    cur = Math.max(0, Math.min(imgs.length - 1, idx));
    lbImg.src = imgs[cur];
    lbPrev.disabled = cur <= 0;
    lbNext.disabled = cur >= imgs.length - 1;
    resetZoom();
  }
  function openLightbox(idx, imgs) {
    show(idx, imgs);
    lb.classList.add("is-open");
    document.body.style.overflow = "hidden";
    lb._imgs = imgs;
  }
  function closeLightbox() {
    lb.classList.remove("is-open");
    document.body.style.overflow = "";
    lbImg.src = "";
  }

  lbClose.addEventListener("click", closeLightbox);
  lbPrev.addEventListener("click", () => show(cur - 1, lb._imgs));
  lbNext.addEventListener("click", () => show(cur + 1, lb._imgs));
  lb.addEventListener("click", (e) => { if (e.target === lb) closeLightbox(); });
  document.addEventListener("keydown", (e) => {
    if (!lb.classList.contains("is-open")) return;
    if (e.key === "Escape") closeLightbox();
    if (e.key === "ArrowLeft") show(cur - 1, lb._imgs);
    if (e.key === "ArrowRight") show(cur + 1, lb._imgs);
  });

  // zoom: wheel (desktop)
  lb.addEventListener("wheel", (e) => {
    if (!lb.classList.contains("is-open")) return;
    e.preventDefault();
    const r = lbImg.getBoundingClientRect();
    const px = e.clientX - r.left, py = e.clientY - r.top;
    const factor = e.deltaY < 0 ? 1.18 : 1 / 1.18;
    const ns = Math.max(1, Math.min(5, scale * factor));
    if (ns <= 1) { resetZoom(); return; }
    tx = px - (px - tx) * (ns / scale);
    ty = py - (py - ty) * (ns / scale);
    scale = ns;
    lb.classList.add("is-zoomed");
    applyTf();
  }, { passive: false });

  // zoom: double click/tap toggle
  lbImg.addEventListener("dblclick", (e) => {
    const r = lbImg.getBoundingClientRect();
    if (scale > 1) { resetZoom(); return; }
    scale = 2.4;
    tx = e.clientX - r.left - r.width / 2; ty = e.clientY - r.top - r.height / 2;
    lb.classList.add("is-zoomed"); applyTf();
  });

  // pan (mouse + touch unified)
  lbImg.addEventListener("pointerdown", (e) => {
    if (scale <= 1) { dragStart = { x: e.clientX, t: Date.now() }; return; }
    panStart = { x: e.clientX, y: e.clientY, tx, ty };
    lbImg.setPointerCapture(e.pointerId);
  });
  lbImg.addEventListener("pointermove", (e) => {
    if (!panStart) return;
    tx = panStart.tx + (e.clientX - panStart.x);
    ty = panStart.ty + (e.clientY - panStart.y);
    applyTf();
  });
  lbImg.addEventListener("pointerup", (e) => {
    if (panStart) { panStart = null; return; }
    if (!dragStart) return;
    const dx = e.clientX - dragStart.x;
    if (Math.abs(dx) > 40) { dx < 0 ? show(cur + 1, lb._imgs) : show(cur - 1, lb._imgs); }
    dragStart = null;
  });

  // touch: double-tap zoom
  lbImg.addEventListener("touchend", (e) => {
    const now = Date.now();
    if (now - lastTap < 300) {
      const r = lbImg.getBoundingClientRect();
      const t = (e.changedTouches || [])[0];
      if (scale > 1) { resetZoom(); }
      else if (t) { scale = 2.4; tx = t.clientX - r.left - r.width / 2; ty = t.clientY - r.top - r.height / 2; lb.classList.add("is-zoomed"); applyTf(); }
    }
    lastTap = now;
  });

  document.querySelectorAll(".pp2-gallery-thumbs-row").forEach((row) => {
    const section = row.closest("section") || row.parentElement;
    const main = section.querySelector(".pp2-gallery-main");
    const rail = row.querySelector(".pp2-gallery-thumbs");
    const prevBtn = row.querySelector(".pp2-gallery-thumb-prev");
    const nextBtn = row.querySelector(".pp2-gallery-thumb-next");
    if (!main || !rail) return;

    // pijlen op de grote foto (HTML ontbrak in template, logica bestond al):
    const mainPrev = document.createElement("button");
    mainPrev.type = "button";
    mainPrev.className = "pp2-gallery-main-prev";
    mainPrev.setAttribute("aria-label", "Previous photo");
    mainPrev.innerHTML = "&#8249;";
    const mainNext = document.createElement("button");
    mainNext.type = "button";
    mainNext.className = "pp2-gallery-main-next";
    mainNext.setAttribute("aria-label", "Next photo");
    mainNext.innerHTML = "&#8250;";
    const navSt = document.createElement("style");
    navSt.textContent = `
.pp2-gallery-main-prev,.pp2-gallery-main-next{position:absolute;top:50%;transform:translateY(-50%);width:40px;height:40px;border-radius:50%;border:1px solid var(--pp2-border,#d8dee6);background:rgba(255,255,255,.85);color:var(--pp2-navy,#15233b);font-size:22px;line-height:1;display:grid;place-items:center;cursor:pointer;z-index:3;backdrop-filter:blur(3px);transition:background .15s,opacity .15s}
.pp2-gallery-main-prev:hover,.pp2-gallery-main-next:hover{background:#fff}
.pp2-gallery-main-prev{left:10px}.pp2-gallery-main-next{right:10px}
.pp2-gallery-main-prev:disabled,.pp2-gallery-main-next:disabled{opacity:0;pointer-events:none}
@media (max-width:749px){.pp2-gallery-main-prev,.pp2-gallery-main-next{width:34px;height:34px;font-size:19px}.pp2-gallery-main-prev{left:6px}.pp2-gallery-main-next{right:6px}}
`;
    document.head.appendChild(navSt);
    main.appendChild(mainPrev);
    main.appendChild(mainNext);

    const thumbs = Array.from(rail.querySelectorAll(".pp2-gallery-thumb"));
    const imgs = Array.from(main.querySelectorAll(".pp2-gallery-img"));
    const fullSrcs = imgs.map((img) => img.dataset.fullSrc || img.src);

    function updateRailEnds() {
      const atStart = rail.scrollLeft < 4;
      const atEnd = rail.scrollLeft > rail.scrollWidth - rail.clientWidth - 4;
      const overflow = rail.scrollWidth > rail.clientWidth + 4;
      [prevBtn, nextBtn].forEach((btn) => btn && btn.classList.toggle("is-hidden", !overflow));
      if (prevBtn) prevBtn.disabled = atStart;
      if (nextBtn) nextBtn.disabled = atEnd;
      if (!overflow || (atStart && atEnd)) {
        rail.style.maskImage = "";
        rail.style.webkitMaskImage = "";
      } else {
        const mask = "linear-gradient(to right," + (atStart ? "black 0" : "transparent 0,black 28px") + ",black calc(100% - 28px)" + (atEnd ? ",black 100%" : ",transparent 100%") + ")";
        rail.style.maskImage = mask;
        rail.style.webkitMaskImage = mask;
      }
    }

    function updateMainNavStates(idx) {
      if (mainPrev) mainPrev.disabled = idx <= 0;
      if (mainNext) mainNext.disabled = idx >= thumbs.length - 1;
    }

    function selectThumb(btn) {
      const index = thumbs.indexOf(btn);
      if (index < 0) return;
      main.querySelectorAll(".pp2-gallery-img").forEach((img) => {
        const active = img.dataset.galleryIndex === btn.dataset.galleryIndex;
        if (active && img.dataset.fullSrc) {
          img.src = img.dataset.fullSrc;
          delete img.dataset.fullSrc;
        }
        img.style.opacity = active ? "1" : "0";
        img.style.pointerEvents = active ? "auto" : "none";
      });
      thumbs.forEach((t) => t.classList.toggle("is-active", t === btn));
      updateMainNavStates(index);
      const railRect = rail.getBoundingClientRect();
      const btnRect = btn.getBoundingClientRect();
      if (btnRect.left < railRect.left) {
        rail.scrollBy({ left: btnRect.left - railRect.left - 10, behavior: "smooth" });
      } else if (btnRect.right > railRect.right) {
        rail.scrollBy({ left: btnRect.right - railRect.right + 10, behavior: "smooth" });
      }
    }

    thumbs.forEach((btn) => btn.addEventListener("click", () => selectThumb(btn)));

    // pijltjes naast de miniaturenbalk: balk scrollen (vaste stap)
    if (prevBtn) prevBtn.addEventListener("click", () => rail.scrollBy({ left: -(rail.clientWidth - 86), behavior: "smooth" }));
    if (nextBtn) nextBtn.addEventListener("click", () => rail.scrollBy({ left: rail.clientWidth - 86, behavior: "smooth" }));

    // pijltjes op de grote foto: vorige/volgende foto
    function currentIndex() {
      const i = thumbs.findIndex((t) => t.classList.contains("is-active"));
      return i < 0 ? 0 : i;
    }
    if (mainPrev) mainPrev.addEventListener("click", () => selectThumb(thumbs[Math.max(0, currentIndex() - 1)]));
    if (mainNext) mainNext.addEventListener("click", () => selectThumb(thumbs[Math.min(thumbs.length - 1, currentIndex() + 1)]));

    // klik op grote foto -> zoom-lightbox
    main.addEventListener("click", (e) => {
      if (e.target.closest(".pp2-gallery-main-prev, .pp2-gallery-main-next")) return;
      const active = main.querySelector('.pp2-gallery-img[style*="opacity: 1"], .pp2-gallery-img[style*="opacity:1"]');
      let idx = active ? imgs.indexOf(active) : 0;
      if (idx < 0) idx = 0;
      openLightbox(idx, fullSrcs);
    });

    rail.addEventListener("scroll", updateRailEnds);
    window.addEventListener("resize", updateRailEnds);
    updateRailEnds();
    updateMainNavStates(currentIndex());
  });
});
